import {
  HttpErrorResponse, HttpEvent, HttpHandler,
  HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '@core/services/notification.service';
import { TranslocoService } from '@ngneat/transloco';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private notifService: NotificationService, private spinner: NgxSpinnerService, private transloco: TranslocoService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req)
      .pipe(
        catchError((error: HttpErrorResponse) => {

          if (error instanceof HttpErrorResponse) {

            let msg: string;
            const url: string = error.url.split('api')[1];

            // sayfa bulunamadıysa
            if (error.status === 404) { msg = `${this.transloco.translate('HTTP_REQUESTS.NOT_FOUND')} <br> <b>${url}</b>`; }

            // yetki yoksa
            else if (error.status === 401 || error.status === 403) {
              msg = `${this.transloco.translate('HTTP_REQUESTS.NOT_AUTHORIZED')} <br> <b>${url}</b>`;
              this.authService.logout();
            }

            // yukarıdakilerin dışındaysa
            else { msg = error.message ? error.message : error.toString(); }

            // bildirim servisine mesaj gönderiyoruz.
            if (msg) {
              this.notifService.show('error', navigator.onLine ? msg : this.transloco.translate('HTTP_REQUESTS.NOT_CONNECTED'));
            }

          } else {
            this.notifService.show('error', error);
          }

          this.spinner.hide();
          return throwError(error);
        }));
  }

}
